import { Socket, io } from "socket.io-client";

import { BASE_URL } from "@/configs";

// Single shared client so multiple components subscribe to the same
// connection. Re-created if the token changes (e.g. login/logout).
let socket: Socket | null = null;
let currentToken: string | null = null;

export const getSocket = (token: string | null): Socket | null => {
  if (!token) {
    if (socket) {
      socket.disconnect();
      socket = null;
      currentToken = null;
    }

    return null;
  }

  if (socket && currentToken === token) return socket;

  // New or rotated token: tear down the previous socket so the server-side
  // auth middleware re-runs with the fresh credential and re-joins the
  // user's room.
  if (socket) socket.disconnect();

  currentToken = token;
  socket = io(BASE_URL, {
    auth: { token },
    transports: ["websocket", "polling"],
    autoConnect: true,
  });

  return socket;
};

export const disconnectSocket = (): void => {
  if (socket) socket.disconnect();
  socket = null;
  currentToken = null;
};
